import type { ApprovedWeeklyObjective } from "@/services/api/cronos/tracking/students/get-situation"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { CheckCircle2 } from "lucide-react"

interface ObjectivesListProps {
  objectives: ApprovedWeeklyObjective[]
}

export default function ObjectivesList({ objectives }: ObjectivesListProps) {
  return (
    <Card className="h-fit border-none shadow-sm">
      <CardHeader>
        <CardTitle className="text-sm font-bold text-foreground">
          Objetivos cumplidos esta semana
        </CardTitle>
      </CardHeader>
      <CardContent>
        {objectives.length === 0 ? (
          <div className="flex flex-col gap-2">
            <CardDescription className="text-sm text-muted-foreground">
              No hay objetivos cumplidos esta semana
            </CardDescription>
          </div>
        ) : (
          <div className="flex flex-col gap-2">
            {objectives.map((objective) => (
              <div key={objective.id} className="inline-flex items-center gap-2">
                <CheckCircle2 className="size-4 text-primary-500" />
                <span className="text-sm font-medium">{objective.name}</span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
